import { baseClient } from '../common';
import { LoginModel } from './login.model';
import { LoginResponseModel } from './login-response.model';
import { UserModel } from './user.model';

const apiUrl = '/api/auth';

export const authClient = {
  login(body: LoginModel): Promise<LoginResponseModel> {
    return baseClient.body({
      url: `${apiUrl}/login`,
      method: 'POST',
      body,
    });
  },

  logout(): Promise<void> {
    return baseClient.body({
      url: `${apiUrl}/logout`,
      method: 'POST',
      body: {},
    });
  },

  getActiveUser(): Promise<UserModel> {
    return baseClient.get(`${apiUrl}/active-user`);
  },
};
